export const onlyDigits = (value) => String(value ?? "").replace(/\D+/g, "");

export const inferCpfFields = (cpfRaw) => {
  const digits = onlyDigits(cpfRaw);
  if (digits.length === 11) {
    return { indicadorCpf: "1", pais: "BR", cpf: digits };
  }
  return { indicadorCpf: "7", pais: "", cpf: "" };
};

export const buildIn1888Line = (registro, cols) => {
  const normalized = [registro, ...cols].map((value) =>
    value === null || value === undefined ? "" : String(value)
  );
  return normalized.join("|");
};
